export default {
  chooseChannel: {
    text1: 'どうやってGitTapのことを',
    text2: '知りましたか？'
  },
  channelNone: '未選択'
}
